<template>
  <range
    :label="$t('edit.sidebar.border_radius')"
    min="0"
    max="50"
    step="1"
    :value="value()"
    :change="onChange"
    :move="onMove"
  ></range>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Range from '../../../../general/Range.vue';

const defaultValue = 5;

export default {
  props: [
    'item',
    'general',
  ],
  components: {
    Range,
  },
  methods: {
    value() {
      const style = this.stepStyle(this.item);

      if (!style || !style.borderRadius) {
        return defaultValue;
      }

      return style.borderRadius.replace('px', '');
    },
    onChange(value) {
      if (this.general) {
        return this.quizUpdateStyle({
          item: this.item,
          rule: 'borderRadius',
          value: `${value}px`,
        });
      }

      return this.stepUpdateStyle({
        item: this.item,
        rule: 'borderRadius',
        value: `${value}px`,
      });
    },
    onMove(value) {
      if (this.general) {
        return this.quizPreviewStyleChange({
          item: this.item,
          rule: 'borderRadius',
          value: `${value}px`,
        });
      }

      return this.stepPreviewStyleChange({
        item: this.item,
        rule: 'borderRadius',
        value: `${value}px`,
      });
    },
    ...mapActions([
      'quizUpdateStyle',
      'quizPreviewStyleChange',
      'stepUpdateStyle',
      'stepPreviewStyleChange',
    ]),
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** BorderRadius.vue?3d80c571
 **/